/**
 * compare two array for matches
 * @param {object[]} firstArray
 * @param {object[]} secondArray
 * @param {string} firstKey
 * @param {string} secondKey
 * @returns equal objects in an array
 */
export const filterByKey = (firstArray, secondArray, firstKey, secondKey) => {
  let response = [];
  response = firstArray.filter(el => {
    return secondArray.find(element => {
      return element[secondKey] === el[firstKey];
    });
  });
  return response;
};
